import { Style } from '@wix/thunderbolt-becky-types'
import { StylableDriver, StylableEditor, StylesheetDriver } from '@wix/stylable-panel-drivers'
import * as stylableSantaFlatten from '@wix/stylable-santa-flatten/cjs'
import _ from 'lodash'

const getStylableCompFonts = (styleItem: Style) => {
	const stcss = getSTCSS(styleItem)
	return stylableSantaFlatten.fontStylable.findFontsInCss(stcss, () => true, false)
}

const getSTCSS = (styleItem: Style): string =>
	_.get(styleItem, ['style', 'properties', '$st-css'], _.get(styleItem, ['style', 'properties', 'st-css'], ''))

const getStylableCompCss = (
	stylableEditorInstance: StylableEditor,
	namespace: string,
	styleItem: Style,
	isMobileView: boolean,
	_experiments: Record<string, string | true>
	/* themeCounter: number*/
) => {
	const componentStyle = getSTCSS(styleItem)

	const styleWithDirectives = getStyleWithDirectives(componentStyle, isMobileView)
	const meta = getTransformedMeta(stylableEditorInstance.stylableDriver, namespace, styleWithDirectives)
	return meta.outputAst!.toString()
}

const getStyleWithDirectives = (componentStyle: string, isMobileView: boolean): string => {
	return stylableSantaFlatten.addStylableDirectiveRules(componentStyle, isMobileView, {
		breakpoints: true,
		siteColors: true,
		fontClasses: true,
		additionalJsModules: true,
	})
}

const getTransformedMeta = (
	stylableDriver: StylableDriver,
	namespace: string,
	componentStyle: string
): ReturnType<StylesheetDriver['getMeta']> => {
	stylableDriver.writeFile('/currently-transpiling.st.css', '') // TODO we can refactor this to not use writeFile

	const metaBefore = stylableDriver.stylable.fileProcessor.processContent(
		componentStyle,
		'/currently-transpiling.st.css'
	)
	metaBefore.namespace = namespace
	const { meta } = stylableDriver.stylable.transform(metaBefore)
	return meta
}

function updatePanelFsSideEffectForEditing(
	styleId: string,
	namespace: string,
	stylableDriver: StylableDriver,
	componentStyle: string,
	fixDisabledAttribute: boolean
) {
	const path = `/${styleId}.st.css`
	const fixedStyle = fixDisabledAttribute
		? stylableSantaFlatten.fixDisabledAttributeToPseudoStateInCss(componentStyle)
		: componentStyle // see https://jira.wixpress.com/browse/STYL-877
	stylableDriver.writeFile(path, fixedStyle)
	stylableDriver.getStylesheetMeta(path).namespace = namespace
}

const getStylableCompCssWithOverrides = (
	stylableEditorInstance: StylableEditor,
	namespace: string,
	styleItem: Style,
	isMobileView: boolean,
	experiments: Record<string, string | true>
) => {
	const componentStyle = getSTCSS(styleItem)
	const { stylableDriver } = stylableEditorInstance
	const fixDisabledAttribute = experiments['specs.thunderbolt.fixStylableDisabledAttribute'] === true

	const styleWithDirectives = getStyleWithDirectives(componentStyle, isMobileView)
	// In editing time, fs needs to be updated for panel
	updatePanelFsSideEffectForEditing(
		styleItem.id,
		namespace,
		stylableDriver,
		styleWithDirectives,
		fixDisabledAttribute
	)

	const meta = getTransformedMeta(stylableDriver, namespace, styleWithDirectives)
	stylableDriver.applyEditorTransformations(meta)
	return meta.outputAst!.toString()
}

export {
	getStylableCompCss,
	getTransformedMeta,
	getStylableCompFonts,
	getSTCSS,
	getStyleWithDirectives,
	getStylableCompCssWithOverrides,
}
